import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';

import {
  ManualNotificationsItemInput,
  GetManualNotificationsQueryVariables,
  UserSegmentFragment,
  useCreateManualNotificationMutation,
  ManualNotificationType,
} from 'api';
import { useNotify } from 'hooks';
import { ManualNotificationSchema } from 'features/admin/validations';
import { useCreateManualNotification } from 'features/admin/updaters';

import Form from './Form';

interface IProps {
  segments: UserSegmentFragment[];
  queryVariables: GetManualNotificationsQueryVariables;
}

const CreateMessage: FC<IProps> = ({ segments, queryVariables }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const mutationOptions = useCreateManualNotification(queryVariables);
  const { mutateAsync } = useCreateManualNotificationMutation(mutationOptions);

  const initialValues: ManualNotificationsItemInput = {
    notification_type: ManualNotificationType.Now,
    send_at: null,
    segment_ids: [],
    message: {
      body: '',
      url: '',
    },
    email: null,
    entire_company: true,
  };

  function handleSubmit(
    data: ManualNotificationsItemInput,
    actions: FormikHelpers<ManualNotificationsItemInput>
  ) {
    data.message.url = data.message.url || null;
    void mutateAsync({ data }).then(() => {
      notify.info({ message: t('messages:createManualNotificationMessageSuccess') });
      actions.resetForm();
      actions.setFieldValue('entire_company', true);
      actions.setFieldValue('segment_ids', []);
    });
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={ManualNotificationSchema}
    >
      <FormikForm>
        <Form titleI18nKey="messages:newCompanyMessage" segments={segments} />
      </FormikForm>
    </Formik>
  );
};

export default CreateMessage;
